export { Editorial, EditorialItem } from './Editorial'
export type { EditorialProps, EditorialItemProps } from './Editorial'
